import { render, staticRenderFns } from "./IntroductionVideo.vue?vue&type=template&id=2c22ca1f&scoped=true&lang=pug&"
import script from "./IntroductionVideo.vue?vue&type=script&lang=ts&"
export * from "./IntroductionVideo.vue?vue&type=script&lang=ts&"
import style0 from "./IntroductionVideo.vue?vue&type=style&index=0&id=2c22ca1f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22ca1f",
  null
  
)

export default component.exports